import { useMemo } from "preact/hooks";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/ui/shadcn/tabs";
import { getL11nString } from "@/l11n/l11n";
import PhoneNumberInput from "@/ui/components/PhoneNumberInput";
import EmailInput from "@/ui/components/EmailInput";

export default function EmailPhoneInputWrapper({ onSubmit, onFocus, onBlur }) {
  const strings = useMemo(
    () => ({
      placeholder: getL11nString("enter_email_or_phone"),
      submit: getL11nString("submit"),
      email_phone_input_detail: getL11nString("email_phone_input_detail"),
      privacy_policy: getL11nString("privacy_policy"),
      email_mode: getL11nString("email_at"),
      phone_mode: getL11nString("phone_hash"),
      email_at: getL11nString("email_at"),
      phone_hash: getL11nString("phone_hash"),
      input_placeholder_email: getL11nString("input_placeholder_email"),
      input_placeholder_phone: getL11nString("input_placeholder_phone"),
      unlock_your_free_assessment: getL11nString("unlock_your_free_assessment"),
    }),
    []
  );

  return (
    <Tabs defaultValue="email" className="w-full flex flex-col items-start">
      <TabsList>
        <TabsTrigger className="mr-1" value="email">
          {strings.email_mode}
        </TabsTrigger>
        <TabsTrigger className="" value="whatsapp">
          WhatsApp
        </TabsTrigger>
        <TabsTrigger className="ml-1" value="sms">
          SMS
        </TabsTrigger>
      </TabsList>
      <TabsContent value="email" className="w-full">
        <EmailInput
          strings={strings}
          onSubmit={onSubmit}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </TabsContent>
      <TabsContent value="whatsapp">
        <PhoneNumberInput
          strings={strings}
          onSubmit={onSubmit}
          onFocus={onFocus}
          onBlur={onBlur}
          useWhatsApp={true}
        />
      </TabsContent>
      <TabsContent value="sms">
        <PhoneNumberInput
          strings={strings}
          onSubmit={onSubmit}
          onFocus={onFocus}
          onBlur={onBlur}
          useWhatsApp={false}
        />
      </TabsContent>
    </Tabs>
  );
}
